module.exports = __webpack_public_path__ + "static/pexels-cottonbro-4033340_new-d4f0d2fa389d1b912fcfcf03e0d28efa.jpg";